import { apiUrl } from "../../constants";
import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const generateApiKey = createAsyncThunk(
  "integrations/generateApiKey",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(
        `${apiUrl}/generate_api_key`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const errorText = await response.text();
          const errorObj = JSON.parse(errorText);
          errorMessage = errorObj.error || errorMessage;
        } catch (e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Failed generating API key:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const generateApiKeySlice = createSlice({
  name: "integrations",
  initialState: {
    apiKey: "",
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
  },
  reducers: {
    resetGenerateApiKeyState(state) {
      state.apiKey = "";
      state.status = "idle";
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(generateApiKey.pending, (state) => {
        state.status = "loading";
      })
      .addCase(generateApiKey.fulfilled, (state, action) => {
        state.apiKey = action.payload.key;
        state.status = "success";
        state.error = null;
      })
      .addCase(generateApiKey.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetGenerateApiKeyState } = generateApiKeySlice.actions;
export default generateApiKeySlice.reducer;
